import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

// Defensive: never log Authorization headers, tokens, or raw envelopes.
const client = axios.create({
  baseURL: BASE,
  timeout: 12000,
  headers: { "Content-Type": "application/json" },
});

export async function getKatlasStatus() {
  const r = await client.get("/api/katlas/status");
  return r.data;
}

export async function getKatlasDiagnostics() {
  const r = await client.get("/api/katlas/diagnostics?probe=full");
  return r.data;
}

export async function getHealth() {
  const r = await client.get("/api/health");
  return r.data;
}

export async function submitGovernedAction(payload) {
  // payload = { action, outcome, actor, authority_gate, custody, context }
  try {
    const r = await client.post("/api/receipts/governed-action", payload);
    return { ok: true, receipt: r.data };
  } catch (err) {
    const status = err?.response?.status;
    const data = err?.response?.data;
    return { ok: false, status, error: data };
  }
}

export async function getPublicReceipt(hash) {
  const r = await client.get(`/api/receipts/${encodeURIComponent(hash)}/public`);
  return r.data;
}
